import { Dropdown } from "@/atoms-react/dropdown/index.react";
import { Base } from "@/atoms-react/text/Text.react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import { Fragment } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";

type pagintationType = {
  handleNext: () => void;
  setLimit: (limit: number) => void;
  handlePrev: () => void;
  onClick: (page: number) => void;
  currentPage: number;
  totalPages: number;
  limit: number;
  count: number;
};
export const Pagination = ({
  handleNext,
  handlePrev,
  currentPage,
  onClick,
  setLimit,
  limit,
  totalPages,
  count
}: pagintationType) => {
  const { t } = useTranslation(["wallet"]);
  const totalPagesneeded = Math.ceil(count / limit);

  return (
    <div className="mt-3 flex flex-wrap items-center justify-between bg-white py-2 dark:bg-slate-950">
      <div className="flex items-center justify-start">
        <div className="flex flex-row">
          <Dropdown
            className={"no-overflow inline-block w-28 w-full"}
            items={[10, 25, 50].map((limit) => ({
              key: limit.toString(),
              value: limit.toString(),
              render: ({ key, value }) => (
                <Fragment key={key}>
                  <div className={"flex w-full items-center justify-between"}>
                    <Base>{value}</Base>
                  </div>
                </Fragment>
              )
            }))}
            showChevrons
            value={limit?.toString()}
            onChange={({ value }) => {
              setLimit(Number(value));
              onClick(1);
            }}
          />
          <div className="ml-3 flex flex-col justify-center md:whitespace-nowrap">
            <Base> {t("kypay.pagination")}</Base>
          </div>
        </div>
      </div>
      <div className="mt-2 flex md:mt-0">
        {totalPagesneeded <= 5 ? (
          <div className="flex">
            {currentPage > 1 && (
              <ChevronLeftIcon
                onClick={() => {
                  handlePrev();
                }}
                className="mr-4 h-6 w-6 cursor-pointer text-black hover:font-bold"
              />
            )}

            {[1, 2, 3, 4, 5].slice(0, totalPages).map((value, index) => (
              <Base
                onClick={() => {
                  if (index + 1 === currentPage) return;
                  onClick(index + 1);
                }}
                key={index}
                className={twMerge(
                  "ml-4 cursor-pointer",
                  currentPage === index + 1 &&
                    "cursor-pointer rounded-sm border-2 border-primary px-2 font-bold"
                )}
              >
                {value}
              </Base>
            ))}
            {currentPage < totalPages && (
              <ChevronRightIcon
                onClick={() => {
                  if (currentPage === totalPages) return;
                  handleNext();
                }}
                className="ml-4 h-6 w-6 cursor-pointer text-black hover:font-bold"
              />
            )}
          </div>
        ) : (
          <div className="flex">
            {currentPage > 1 && (
              <ChevronLeftIcon
                onClick={() => {
                  handlePrev();
                }}
                className="h-6 w-6 cursor-pointer text-black hover:font-bold"
              />
            )}
            <Base
              className={twMerge(
                "ml-8 cursor-pointer",
                currentPage === 1 &&
                  "cursor-pointer rounded-sm border-2 border-primary px-2 font-bold"
              )}
              onClick={() => {
                onClick(1);
              }}
            >
              {1}
            </Base>
            <Base
              className={twMerge(
                "ml-4 cursor-pointer",
                currentPage === 2 &&
                  "cursor-pointer rounded-sm border-2 border-primary px-2 font-bold"
              )}
              onClick={() => {
                onClick(2);
              }}
            >
              {2}
            </Base>
            <Base
              className={twMerge(
                "ml-4 cursor-pointer",
                currentPage === 3 &&
                  "cursor-pointer rounded-sm border-2 border-primary px-2 font-bold"
              )}
              onClick={() => {
                onClick(3);
              }}
            >
              {3}
            </Base>
            <Base
              className={twMerge(
                "ml-4 cursor-pointer",
                currentPage === 4 &&
                  "cursor-pointer rounded-sm border-2 border-primary px-2 font-bold"
              )}
              onClick={() => {
                onClick(4);
              }}
            >
              {4}
            </Base>
            <Base
              className={twMerge(
                "ml-4 cursor-pointer",
                (currentPage === 5 || (currentPage > 5 && currentPage < totalPages)) &&
                  "cursor-pointer rounded-sm border-2 border-primary px-2 font-bold"
              )}
              onClick={() => {
                onClick(
                  currentPage > 5 ? (currentPage === totalPages ? totalPages - 1 : currentPage) : 5
                );
              }}
            >
              {currentPage > 5 ? (currentPage === totalPages ? totalPages - 1 : currentPage) : 5}
            </Base>
            <Base className={twMerge("ml-4")}>...</Base>
            <Base
              className={twMerge(
                "ml-4",
                currentPage === totalPages && "rounded-sm border-2 border-primary px-2 font-bold"
              )}
            >
              {totalPages}
            </Base>
            {currentPage < totalPages && (
              <ChevronRightIcon
                onClick={() => {
                  if (currentPage === totalPages) return;
                  handleNext();
                }}
                className="ml-8 h-6 w-6 cursor-pointer text-black hover:font-bold"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
